
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesItemsGrid extends Serenity.EntityGrid<SalesItemsRow, any> {
        protected getColumnsKey() { return 'Sales.SalesItems'; }
        protected getDialogType() { return SalesItemsDialog; }
        protected getIdProperty() { return SalesItemsRow.idProperty; }
        protected getInsertPermission() { return SalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesItemsRow.localTextPrefix; }
        protected getService() { return SalesItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }        
        
    }
}